import { createSlice } from "@reduxjs/toolkit";
import { getAxios, postAxios, postRRAxios } from "./axiosActions";
import { fetchLocations, getMasterDataUpdateSuccess, masterDataDelete, promptUpdate } from "./location";
import { PlaylistAddRounded } from "@mui/icons-material";
import { set } from "lodash";


export const initialState = {
  loading: false,
  hasErrors: false,
  prompts: [],
  promptTemplates: [],
  updatePrompt: [],
  createPrompt: [],
  deletePrompt: [],
  vanillaPrompt: {},
  copyPrompt: [],
  historyPromptDetails: [],
  promptsComparisionData: [],
  promptsCache:{dev:[],prod:[],demo:[],test:[]},
  promptPreview:'',
  systemPromptPreview:'',
  selectedPromptData:[],
  redFlagInputData: '', // ADD THIS LINE
  loadingRedFlagData: false, // ADD THIS LINE
  runPromptId:null,
  envAssignments:[],
};

const promptsSlice = createSlice({
  name: "prompts",
  initialState,
  reducers: {
    getPromptsCache:(state,{payload})=>{
      state.promptsCache[payload.key]=payload.data
    },
    getprompts: (state) => {
      state.loading = true;
    },
    getpromptsSuccess: (state, { payload }) => {
      state.prompts = payload;
      state.loading = false;
      state.hasErrors = false;
    },
    getpromptsFailure: (state) => {
      state.loading = false;
      state.hasErrors = true;
    },
    getPromptTemplates: (state) => {
      state.loading = true;
    },
    getPromptTemplatesSuccess: (state, { payload }) => {
      state.promptTemplates = payload;
      state.loading = false;
      state.hasErrors = false;
    },
    getPromptTemplatesFailure: (state) => {
      state.loading = false;
      state.hasErrors = true;
    },
    getCreatePrompt: (state) => {
      state.loading = true;
    },
    getCreateCreatePromptuccess: (state, { payload }) => {
      state.createPrompt = payload;
      state.loading = false;
      state.hasErrors = false;
    },
    getCreatePromptFailure: (state) => {
      state.loading = false;
      state.hasErrors = true;
    },
    getUpdatePrompt: (state) => {
      state.loading = true;
    },
    getCreateUpdatePromptuccess: (state, { payload }) => {
      state.updatePrompt = payload;
      state.loading = false;
      state.hasErrors = false;
    },
    getUpdatePromptFailure: (state) => {
      state.loading = false;
      state.hasErrors = true;
    },
    getDeletePrompt: (state) => {
      state.loading = true;
    },
    getDeletePromptSuccess: (state, { payload }) => {
      state.deletePrompt = payload;
      state.loading = false;
      state.hasErrors = false;
    },
    getDeletePromptFailure: (state) => {
      state.loading = false;
      state.hasErrors = true;
    },
    getVanillaPrompt: (state) => {
      state.loading = true;
    },
    getVanillaPromptSuccess: (state, { payload }) => {
      state.vanillaPrompt = payload;
      state.loading = false;
      state.hasErrors = false;
    },
    getVanillaPromptFailure: (state) => {
      state.loading = false;
      state.hasErrors = true;
    },
    getCopyPrompt: (state) => {
      state.loading = true;
    },
    getCopyPromptSuccess: (state, { payload }) => {
      state.copyPrompt = payload;
      state.loading = false;
      state.hasErrors = false;
    },
    getCopyPromptFailure: (state) => {
      state.loading = false;
      state.hasErrors = true;
    },
    getHistoryPromptDetails: state => {
      state.loading = true;
      state.hasErrors = false;
    },
    getHistoryPromptDetailsSuccess: (state, { payload }) => {
      state.loading = true;
      state.hasErrors = false;
      state.historyPromptDetails = payload
    },
    getHistoryPromptDetailsError: state => {
      state.loading = false;
      state.hasErrors = true;
    },
    removeHistoryPrompts: state => {
      state.historyPromptDetails = []
    },
    promptsComparision: state => {
      state.loading = true;
      state.hasErrors = false;
    },
    promptsComparisionSuccess: (state, { payload }) => {
      state.loading = true;
      state.hasErrors = false;
      state.promptsComparisionData = payload
    },
    promptsComparisionError: state => {
      state.loading = false;
      state.hasErrors = true;
    },
    removePromptsComparision: state => {
      state.promptsComparisionData = []
    },
    assignPrompt: state => {
      state.isAssignPromptLoading = true;
    },
    assignPromptSuccess: (state, { payload }) => {
      state.isAssignPromptLoading = false;
      state.isAssignPromptError = false;
    },
    assignPromptFailure: state => {
      state.isAssignPromptLoading = false;
      state.isAssignPromptError = true;
    },
    setPromptPreview:(state,{payload})=>{
      state.isAssignPromptLoading = false;
      state.isAssignPromptError = false;
      state.promptPreview=payload
    },
    setSystemPromptPreview:(state,{payload})=>{
      state.isAssignPromptLoading = false;
      state.isAssignPromptError = false;
      state.systemPromptPreview=payload
    },
    setSelectedPromptData:(state,{payload})=>{
      state.selectedPromptData=payload
    },
    setRunPromptId:(state,{payload})=>{
      state.runPromptId=payload
    },
    getEnvAssignmentsSuccess:(state,{payload})=>{
      state.envAssignments=payload??[]
    },
  },
});

export const {
  getprompts,
  getpromptsSuccess,
  getpromptsFailure,
  getPromptTemplates,
  getPromptTemplatesSuccess,
  getPromptTemplatesFailure,
  getCreatePrompt,
  getCreatePromptSuccess,
  getCreatePromptFailure,
  getUpdatePrompt,
  getUpdatePromptSuccess,
  getUpdatePromptFailure,
  getDeletePrompt,
  getDeletePromptSuccess,
  getDeletePromptFailure,
  getVanillaPrompt,
  getVanillaPromptSuccess,
  getVanillaPromptFailure,
  getCopyPrompt,
  getCopyPromptFailure,
  getCopyPromptSuccess,
  getHistoryPromptDetails,
  getHistoryPromptDetailsSuccess,
  getHistoryPromptDetailsError,
  removeHistoryPrompts,
  promptsComparision, setSystemPromptPreview,
  promptsComparisionError, promptsComparisionSuccess, removePromptsComparision, assignPrompt, assignPromptFailure, assignPromptSuccess,setPromptPreview,getPromptsCache, setSelectedPromptData,
  setRunPromptId, getEnvAssignmentsSuccess
} = promptsSlice.actions;
export const promptsSelector = (state) => state.prompts;
export default promptsSlice.reducer;

export function fetchprompts(companyId) {
  return async (dispatch) => {
    dispatch(getprompts());
    try {
      const params = { callTime: new Date() };
      const data = await getAxios(
        "api/Prompts/GetPrompts?companyId=" + companyId,
        { params: params }
      );
      dispatch(getMasterDataUpdateSuccess({ key: 'prompts', data: data }))
      // dispatch(getpromptsSuccess(data));
    } catch (error) {
      dispatch(getpromptsFailure());
    }
  };
}

export function fetchPromptEnvAssignments() {
  return async (dispatch) => {
    try {
      const params = { callTime: new Date() };
      const data = await getAxios(
        "api/Prompts/GetPromptEnvAssignments",
        { params: params }
      );
      dispatch(getEnvAssignmentsSuccess(data));
    } catch (error) {
      dispatch(getEnvAssignmentsSuccess([]));
    }
  };
}

export function fetchPromptTemplates(companyId) {
  return async (dispatch) => {
    dispatch(getPromptTemplates());
    try {
      const params = { callTime: new Date() };
      const data = await getAxios(
        "api/Prompts/GetPromptTemplates?companyId=" + companyId,
        { params: params }
      );
      dispatch(getPromptTemplatesSuccess(data));
    } catch (error) {
      dispatch(getPromptTemplatesFailure());
    }
  };
}

export function fetchVanillaprompt(promptId) {
  return async (dispatch) => {
    dispatch(getVanillaPrompt());
    try {
      const params = { callTime: new Date() };
      const data = await getAxios(
        "api/Prompts/GetPrompt?promptId=" + promptId,
        { params: params }
      );
      dispatch(getVanillaPromptSuccess(data));
    } catch (error) {
      dispatch(getVanillaPromptFailure());
    }
  };
}

export function triggerCreatePrompt(companyId, data) {
  return async (dispatch) => {
    try {
      const response = await postAxios(
        "api/Prompts/CreatePrompt?companyId=" + companyId,
        { params: data }
      );
      // dispatch(getCreatePromptSuccess(response));
      dispatch(setSelectedPromptData(response));
      dispatch(getMasterDataUpdateSuccess({ key: 'prompts', data: response }))
      // dispatch(fetchprompts(companyId))
    } catch (error) {
      dispatch(getCreatePromptFailure());
    }
  };
}

export function triggerUpdatePrompt(promptId, companyId, data,prevData, eventType) {
  return async (dispatch) => {
    try {
      const response = await postAxios(
        "api/Prompts/UpdatePrompt?promptId=" +
        promptId +
        "&companyId=" + companyId + '&eventType='+ eventType, 
        { params: data },
        
      );

      // dispatch(getUpdatePromptSuccess(response));
     await dispatch(getMasterDataUpdateSuccess({ key: 'prompts', data: response }))
      if(prevData){
        dispatch(promptUpdate(prevData))
      }
    } catch (error) {
      dispatch(getUpdatePromptFailure());
    }
  };
}

export function triggerDeletePrompt(promptId, companyId) {
  return async (dispatch) => {
    dispatch(getDeletePrompt());
    try {
      const params = { callTime: new Date() };
      const data = await getAxios(
        "api/Prompts/DeletePrompt?promptId=" + promptId,
        { params: params }
      );
      dispatch(getDeletePromptSuccess(data));
      if(companyId){
       dispatch(masterDataDelete({key:'prompts',data:promptId}))
        // dispatch(fetchLocations(companyId))
      }
    } catch (error) {
      dispatch(getDeletePromptFailure());
    }
  };
}
export function triggerCopyPrompt(promptId, companyId,env) {
  return async (dispatch) => {
    dispatch(getCopyPrompt());
    try {
      const params = { callTime: new Date() };
      const data = await getAxios(
        "api/Prompts/CopyPrompt?promptId=" + promptId,
        { params: params }
      );
      dispatch(getCopyPromptSuccess(data));
      if(companyId){
        dispatch(fetchLocations(companyId,env))
      }
    } catch (error) {
      dispatch(getCopyPromptFailure());
    }
  };
}
export function fetchPromptHistory(promptId) {
  return async (dispatch) => {
    dispatch(getHistoryPromptDetails());
    try {
      const params = { callTime: new Date() };
      const data = await getAxios(
        "api/Prompts/GetPromptHistory?promptId=" + promptId,
        { params: params }
      );
      dispatch(getHistoryPromptDetailsSuccess(data));
    } catch (error) {
      dispatch(getHistoryPromptDetailsError());
    }
  };
}
export function fetchComparisionPrompts(promptId, oldTime, newTime) {
  return async (dispatch) => {
    dispatch(promptsComparision());
    try {
      const params = { callTime: new Date() };
      const data = await getAxios(
        "api/Prompts/GetPromptHistory?promptId=" + promptId + '&oldTime=' + oldTime + '&newTime=' + newTime,
        { params: params }
      );
      dispatch(promptsComparisionSuccess(data));
    } catch (error) {
      dispatch(promptsComparisionError());
    }
  };
}
export function assignPromptToProcess(input, getPrompts) {
  return async dispatch => {
    dispatch(assignPrompt());
    try {
      const params = { callTime: new Date() };
      const data = await postAxios('api/Prompts/AssignPromptToProcess', { params: input });
      await dispatch(assignPromptSuccess(data));
      dispatch(fetchPromptEnvAssignments());

      if (getPrompts) {
        await dispatch(fetchprompts(input.selectedCompanyId))
      }
    } catch (error) {
      dispatch(assignPromptFailure());
    }
  };
}

export function deleteCompanyPromptProcess(input, getPrompts) {
  return async dispatch => {
    
    try {
      const params = { callTime: new Date() };
      const data = await postAxios('api/Prompts/DeleteCompanyPromptProcess', { params: input });
      await dispatch(getSelectedPrompt(data));
      dispatch(fetchPromptEnvAssignments());

      if (getPrompts) {
        await dispatch(fetchprompts(input.selectedCompanyId))
      }
    } catch (error) {
      
    }
  };
}

export function getPromptPreview(input, previewType) {
  return async dispatch => {
    dispatch(assignPrompt());
    try {
      const params = { callTime: new Date() };
      const data = await postAxios('api/OpenAi/GetPromptPreview', { params: input });
      if (previewType === 'system') {
        await dispatch(setSystemPromptPreview(data));
      } else {
        await dispatch(setPromptPreview(data));
      }

    } catch (error) {
      dispatch(assignPromptFailure());
    }
  };
}
export function getSelectedPrompt(data) {
  return async dispatch => {
    try {
      await dispatch(setSelectedPromptData(data));

    } catch (error) {
      console.error(error);
    }
  };
}
export function getPromptFromEnv(env,companyId){
return async dispatch=>{
  try {
    const params = { callTime: new Date() };
    const data = await getAxios(
      "api/Prompts/GetPrompts?companyId=" + companyId,
      { params: params },env
    );
    dispatch(getPromptsCache({ key: env, data: data }));

  } catch (error) {
    dispatch(getpromptsFailure());
  }
}
}
export function copyPromptFromEnv(data,companyId){
  return async dispatch=>{
    try {
      const params = { callTime: new Date() };
      const res = await postAxios("api/Prompts/CopyPromptFromEnv", { params: data } );
      if(res&&companyId){
        dispatch(getPromptFromEnv(data.to.env,companyId))
        dispatch(getPromptFromEnv(data.from.env,companyId))
      }
    } catch (error) {
    }
  }
  }